import React from 'react';
import './committee-selection.css';
import { CommitteeMemberSelector } from './committee-member-selector';
import { Committee } from './committee';
import CommitteeResults from './committee-results';
import { TextButton } from '../../../components/text-button';

const CommitteeSelection = props => {
    const {
        committeeMembers,
        possibleMembers,
        toggleCommitteeMember,
        committeeSelected,
        committeeResults,
        committeeTargets,
        gatherEvidence,
        showProgressUpdateModal,
    } = props;

    return (
        <div className="committee-selection">
            <CommitteeMemberSelector
                committeeMembers={committeeMembers}
                possibleMembers={possibleMembers}
                toggleCommitteeMember={toggleCommitteeMember}
            />
            <div className="committee-selection__selection">
                {committeeSelected ? (
                    <CommitteeResults
                        committeeResults={committeeResults}
                        committeeTargets={committeeTargets}
                        showProgressUpdateModal={showProgressUpdateModal}
                    />
                ) : (
                    <Committee
                        committeeMembers={committeeMembers}
                        possibleMembers={possibleMembers}
                    />
                )}
                <TextButton
                    onClick={gatherEvidence}
                    text="Submit"
                    isDisabled={
                        committeeMembers.length < 6 ||
                        committeeSelected === true
                    }
                />
            </div>
        </div>
    );
};

export { CommitteeSelection };
